import { useSearchParams } from "react-router-dom";

import {
  DEFAULT_POWER_QUALITY_MODE,
  PowerQualityModePicker,
  powerQualityModeOf,
  type PowerQualityMode,
} from "../components/PowerQualityModePicker";
import { HarmonicPage } from "./HarmonicPage";
import { PfCorrectionPage } from "./PfCorrectionPage";

// EOS-11's page: two modes, the power factor correction (11a, the default) and the harmonic
// assessment (11b). The mode is in the address (?mode=pf or ?mode=harmonics; a missing or
// unknown value is pf), so Back, Forward and a shared link restore it. Only the shown mode is
// mounted; each form keeps its draft under its own module key, so changing the mode never
// clears either one.
export function PowerQualityPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = powerQualityModeOf(searchParams.get("mode"));

  function changeMode(next: PowerQualityMode) {
    setSearchParams((current) => {
      const updated = new URLSearchParams(current);
      if (next === DEFAULT_POWER_QUALITY_MODE) {
        updated.delete("mode");
      } else {
        updated.set("mode", next);
      }
      return updated;
    });
  }

  const modePicker = <PowerQualityModePicker mode={mode} onChange={changeMode} />;

  return mode === "harmonics" ? (
    <HarmonicPage modePicker={modePicker} />
  ) : (
    <PfCorrectionPage modePicker={modePicker} />
  );
}

export default PowerQualityPage;
